
export default function LocaisCobranca() {
  return (
    <div>LocaisCobranca</div>
  )
}
